/**
 * Modal — fenêtre modale réutilisable (overlay + carte centrée).
 * Ferme sur clic backdrop, touche Échap, ou bouton ×.
 */
import { useEffect } from "react";
import { colors, fonts } from "../styles/tokens";

export default function Modal({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  size = "md",
}) {
  // Fermeture sur touche Échap
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  const widths = { sm: 420, md: 560, lg: 720, xl: 920 };

  return (
    <div
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 400,
        padding: "20px",
        animation: "fadeIn 180ms ease-out",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: colors.surface,
          border: `1px solid ${colors.border}`,
          borderRadius: "16px",
          width: "100%",
          maxWidth: widths[size] || widths.md,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 25px 60px rgba(0,0,0,0.7)",
          fontFamily: fonts.body,
        }}
      >
        {/* Header */}
        {(title || onClose) && (
          <div
            style={{
              padding: "20px 24px",
              borderBottom: `1px solid ${colors.border}`,
              display: "flex",
              alignItems: "flex-start",
              gap: "16px",
            }}
          >
            <div style={{ flex: 1 }}>
              {title && (
                <h2 style={{ fontFamily: fonts.heading, fontSize: "24px", fontWeight: 700, color: colors.text }}>
                  {title}
                </h2>
              )}
              {subtitle && (
                <div style={{ fontSize: "13px", color: colors.textMuted, marginTop: "4px" }}>
                  {subtitle}
                </div>
              )}
            </div>
            <button
              onClick={onClose}
              aria-label="Fermer"
              style={{
                color: colors.textMuted,
                fontSize: "26px",
                padding: "0 8px",
                lineHeight: 1,
                borderRadius: "8px",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.color = colors.text; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = colors.textMuted; }}
            >
              ×
            </button>
          </div>
        )}

        {/* Body */}
        <div style={{ padding: "24px", overflowY: "auto", flex: 1 }}>
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div
            style={{
              padding: "16px 24px",
              borderTop: `1px solid ${colors.border}`,
              display: "flex",
              gap: "8px",
              justifyContent: "flex-end",
            }}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
